define(
    ['core/browser-storage'], 
    function (browser_storage) {
        return {
            init: function (nodes, pageName) {
                let adjustMetricsHeight = () => {
                    let contentHeight = nodes.metricsContainer.offsetHeight;
                    nodes.wrap.style.height = `${contentHeight + 60}px`;
                }

                let initBenchmarks = () => {
                    nodes.benchmarksToggle.addEventListener("click", (event) => {
                        if(event.target.checked) {
                            // quickly show benchmark elements to gather heights  
                            // in order to set metrics-wrapper height 
                            nodes.main.classList.add("show-benchmarks");
                            adjustMetricsHeight();
                            // hide elements again
                            nodes.main.classList.remove("show-benchmarks");
                    
                            nodes.wrap.classList.add("transitioning");
                    
                            setTimeout(() => {
                                nodes.main.classList.add("show-benchmarks");
                                nodes.wrap.classList.remove("transitioning");
                            }, 500);
                            browser_storage.setItem(`hide-${pageName}-benchmarks`, "false");
                    
                        } else {
                            nodes.wrap.classList.add("transitioning");
                            
                            setTimeout(() => {
                                nodes.main.classList.remove("show-benchmarks");
                                adjustMetricsHeight();
                            }, 400)
                    
                            setTimeout(() => {
                                nodes.wrap.classList.remove("transitioning");
                            }, 400);
                    
                            browser_storage.setItem(`hide-${pageName}-benchmarks`, "true");
                        } 
                    })
                }

                nodes.header.addEventListener("click", () => {
                    nodes.main.classList.contains("collapse") ? nodes.main.classList.remove("collapse") : nodes.main.classList.add("collapse");
                    nodes.main.classList.contains("collapse") ? browser_storage.setItem(`${pageName}-metrics-collapse-v2`, "true") : browser_storage.setItem(`${pageName}-metrics-collapse-v2`, "false"); 
                })

                if(browser_storage.getItem(`${pageName}-metrics-collapse-v2`) === "true") {
                    nodes.main.classList.add("collapse");
                }

                // nodes.header.addEventListener("click", (event) => {
                //     if(browser_storage.getItem(`${pageName}-metrics-collapse`) === "true") {
                //         browser_storage.setItem(`${pageName}-metrics-collapse`, "false");
                //         nodes.header.classList.remove("collapse");
                //     } else {
                //         browser_storage.setItem(`${pageName}-metrics-collapse`, "true");
                //         nodes.main.classList.add("collapse");
                //     }
                // })

                if(browser_storage.getItem(`hide-${pageName}-benchmarks`) === "true") {
                    nodes.benchmarksToggle.checked = false;
                    nodes.main.classList.remove("show-benchmarks");
                    adjustMetricsHeight();
                }
                
                return {
                    initBenchmarks,
                    adjustMetricsHeight,
                }
            }
        }
    }
);
